export const ROOT_ADMIN_EDIPN = '1071532450';

export function isRootAdminIdentity(siteAccessState) {
  return (
    siteAccessState?.isOwner === true &&
    String(siteAccessState?.edipn || '').trim() === ROOT_ADMIN_EDIPN
  );
}
